import React, { useState } from "react";
import Button from "@amzn/meridian/button";
import Select, { SelectOption } from "@amzn/meridian/select";
import Row from "@amzn/meridian/row";

import { ProcessPathConfig } from "../types";

import "./AddProcessPathButton.scss";

export interface AddProcessPathButtonProps {
  availableProcessPaths: ProcessPathConfig[];
  existingProcessPathKeys: string[];
  onAdd: (config: ProcessPathConfig) => void;
  disabled: boolean;
}

const getOptionValue = (pp: ProcessPathConfig) => `${pp.processId}-${pp.functionId}`;

const AddProcessPathButton: React.FC<AddProcessPathButtonProps> = ({
  availableProcessPaths,
  existingProcessPathKeys,
  onAdd,
  disabled,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedValue, setSelectedValue] = useState<string>("");

  const filteredPaths = availableProcessPaths.filter(
    (pp) => !existingProcessPathKeys.includes(getOptionValue(pp))
  );

  const handleAddClick = () => {
    setShowDropdown(true);
  };

  const handleSelection = (value: string) => {
    setSelectedValue(value);
    const selected = filteredPaths.find((pp) => getOptionValue(pp) === value);
    if (selected) {
      onAdd(selected);
      setShowDropdown(false);
      setSelectedValue("");
    }
  };

  const handleCancel = () => {
    setShowDropdown(false);
    setSelectedValue("");
  };

  if (showDropdown) {
    return (
      <Row spacing="300" className="add-process-path-button" alignmentVertical="bottom">
        <Select
          value={selectedValue}
          onChange={handleSelection}
          placeholder="Select a process path"
          width={300}
          data-testid="process-path-select"
        >
          {filteredPaths.map((pp) => (
            <SelectOption
              key={getOptionValue(pp)}
              value={getOptionValue(pp)}
              label={`${pp.functionName} (${pp.functionId})`}
            />
          ))}
        </Select>
        <Button type="tertiary" size="small" onClick={handleCancel}>
          Cancel
        </Button>
      </Row>
    );
  }

  return (
    <div className="add-process-path-button">
      <Button
        type="secondary"
        onClick={handleAddClick}
        disabled={disabled || filteredPaths.length === 0}
        data-testid="add-process-path-btn"
      >
        + Add process path
      </Button>
    </div>
  );
};

export default AddProcessPathButton;

import './AddProcessPathButton.scss';